// Import recipe images
import tiramisuImg from '../../Assets/recipe_images/recipe-tiramisu.png';
import bananaBreadImg from '../../Assets/recipe_images/recipe-banana-bread.png';
import glazedTofuImg from '../../Assets/recipe_images/glazed-tofu.jpg';

import {
    CUISINE_TYPES,
    RECIPE_TYPES,
    KITCHEN_MATERIALS,
    CHEFS
} from './translations';

// Family recipes data
const demoRecipes = [
    {
        id: "classic-italian-tiramisu",
        title: { 
            en: "Tiramisu",
            ua: "Тірамісу", 
            es: "Tiramisú",
            ru: "Тирамису"
        },
        description: { 
            en: "Classic Italian dessert with mascarpone, coffee, and ladyfingers.",
            ua: "Класичний італійський десерт з маскарпоне, кавою та савоярді.",
            es: "Postre italiano clásico con mascarpone, café y bizcochos.",
            ru: "Классический итальянский десерт с маскарпоне, кофе и савоярди."
        },
        prepTime: {
            en: "30 minutes",
            ua: "30 хвилин",
            es: "30 minutos",
            ru: "30 минут"
        },
        cookTime: {
            en: "4-12 hours (chill)",
            ua: "4-12 годин (охолодження)",
            es: "4-12 horas (enfriar)",
            ru: "4-12 часов (охлаждение)"
        },
        ingredients: { 
            en: [
                "4 Eggs",
                "500 gr Mascarpone",
                "5 tbs Confectionary Sugar",
                "200 gr Savoiardi (Ladyfinger) cookies",
                "400 ml Espresso Coffee",
                "1 glass Cognac or Rum"
            ],
            ua: [
                "4 яйця",
                "500 г маскарпоне",
                "5 ст.л. цукрової пудри",
                "200 г савоярді (бісквітне печиво)",
                "400 мл еспресо",
                "1 склянка коньяку або рому"
            ],
            es: [
                "4 huevos",
                "500 gr de mascarpone",
                "5 cucharadas de azúcar glas",
                "200 gr de bizcochos de soletilla",
                "400 ml de café espresso",
                "1 vaso de coñac o ron"
            ],
            ru: [
                "4 яйца",
                "500 г маскарпоне",
                "5 ст.л. сахарной пудры",
                "200 г печенья савоярди",
                "400 мл эспрессо",
                "1 стакан коньяка или рома"
            ]
        },
        instructions: { 
            en: [
                "Separate egg yolks from whites into two bowls, the yolk one being the bigger one.",
                "Combine egg yolks with 4 tbsp of confectionary sugar and mix until pale. Add mascarpone and mix in.",
                "Whip egg whites with 1 tbsp of sugar until heavy foam.",
                "Fold egg whites into yolk mixture gently.",
                "Prepare espresso, let cool, mix with liquor.",
                "Dip ladyfingers into coffee mix, layer in pan.",
                "Pour cream over cookies, repeat layers.",
                "Refrigerate 4-12 hours.",
                "Sprinkle cocoa or chocolate before serving."
            ],
            ua: [
                "Відокремте жовтки від білків у дві миски, жовткова має бути більшою.",
                "Змішайте жовтки з 4 ст.л. цукрової пудри до світлого кольору. Додайте маскарпоне і перемішайте.",
                "Збийте білки з 1 ст.л. цукрової пудри до густої піни.",
                "Обережно введіть білки у жовткову масу.",
                "Приготуйте еспресо, остудіть, змішайте з алкоголем.",
                "Занурте савоярді у каву, викладіть у форму.",
                "Покрийте кремом, повторіть шари.",
                "Охолодіть 4-12 годин.",
                "Перед подачею посипте какао або шоколадом."
            ],
            es: [
                "Separe las yemas de las claras en dos recipientes, el de yemas más grande.",
                "Mezcle las yemas con 4 cucharadas de azúcar glas hasta que estén pálidas. Agregue mascarpone y mezcle.",
                "Bata las claras con 1 cucharada de azúcar hasta que estén firmes.",
                "Incorpore suavemente las claras a la mezcla de yemas.",
                "Prepare espresso, deje enfriar, mezcle con licor.",
                "Sumerja los bizcochos en el café, coloque en el molde.",
                "Vierta la crema sobre las galletas, repita capas.",
                "Refrigere 4-12 horas.",
                "Espolvoree cacao o chocolate antes de servir."
            ],
            ru: [
                "Отделите желтки от белков в две миски, для желтков возьмите миску побольше.",
                "Смешайте желтки с 4 ст.л. сахарной пудры до светлого цвета. Добавьте маскарпоне и перемешайте.",
                "Взбейте белки с 1 ст.л. сахарной пудры до плотной пены.",
                "Аккуратно введите белки в желтковую массу.",
                "Приготовьте эспрессо, остудите, смешайте с алкоголем.",
                "Обмакните савоярди в кофе, выложите в форму.",
                "Покройте кремом, повторите слои.",
                "Охладите 4-12 часов.",
                "Перед подачей посыпьте какао или шоколадом."
            ]
        },
        image: tiramisuImg,
        author: CHEFS.ILLYA_BAKUROV,
        country: "",
        cuisine: CUISINE_TYPES.DESSERT,
        type: RECIPE_TYPES.VEGETARIAN,
        nutrition: {
            kcal: 420,
            protein: 8,
            carbs: 45,
            fat: 22,
            servings: 6
        },
        date: "",
        photos: [tiramisuImg],
        materials: [KITCHEN_MATERIALS.MIXING_BOWL, KITCHEN_MATERIALS.WHISK, KITCHEN_MATERIALS.BAKING_DISH],
        youtube: ""
    },
    {
        id: "banana-bread-blueberries-pecans",
        title: { 
            en: "Banana Bread with Pecans and Blueberries",
            ua: "Банановий хліб з пеканом та чорницею",
            es: "Pan de plátano con nueces pecanas y arándanos",
            ru: "Банановый хлеб с орехами пекан и черникой"
        },
        description: { 
            en: "Moist and delicious banana bread with optional pecans or blueberries.",
            ua: "Вологий та смачний банановий хліб з пеканом або чорницею на вибір.",
            es: "Pan de plátano húmedo y delicioso con nueces pecanas o arándanos opcionales.",
            ru: "Влажный и вкусный банановый хлеб с орехами пекан или черникой по желанию."
        },
        prepTime: {
            en: "15 minutes",
            ua: "15 хвилин",
            es: "15 minutos",
            ru: "15 минут"
        },
        cookTime: {
            en: "55-65 minutes",
            ua: "55-65 хвилин",
            es: "55-65 minutos",
            ru: "55-65 минут"
        },
        ingredients: { 
            en: [
                "2-3 medium very ripe bananas (1 1/4 to 1 1/2 cups mashed)",
                "1/3 cup (76g) butter, melted",
                "1/2 teaspoon baking soda",
                "1 pinch salt",
                "3/4 cup (150g) sugar",
                "1 large egg, beaten",
                "1 teaspoon vanilla extract",
                "1 1/2 cups (205g) all-purpose flour",
                "1/2 cup pecans (optional)",
                "1/2 cup blueberries (optional)"
            ],
            ua: [
                "2-3 середніх дуже стиглих банани (1 1/4 - 1 1/2 склянки пюре)",
                "1/3 склянки (76г) масла, розтопленого",
                "1/2 ч.л. харчової соди",
                "Щіпка солі",
                "3/4 склянки (150г) цукру",
                "1 велике яйце, збите",
                "1 ч.л. ванільного екстракту",
                "1 1/2 склянки (205г) борошна",
                "1/2 склянки пекану (за бажанням)",
                "1/2 склянки чорниці (за бажанням)"
            ],
            es: [
                "2-3 plátanos medianos muy maduros (1 1/4 a 1 1/2 tazas triturados)",
                "1/3 taza (76g) de mantequilla derretida",
                "1/2 cucharadita de bicarbonato de sodio",
                "1 pizca de sal",
                "3/4 taza (150g) de azúcar",
                "1 huevo grande batido",
                "1 cucharadita de extracto de vainilla",
                "1 1/2 tazas (205g) de harina común",
                "1/2 taza de nueces pecanas (opcional)",
                "1/2 taza de arándanos (opcional)"
            ],
            ru: [
                "2-3 средних очень спелых банана (1 1/4 - 1 1/2 стакана пюре)",
                "1/3 стакана (76г) растопленного масла",
                "1/2 ч.л. пищевой соды",
                "Щепотка соли",
                "3/4 стакана (150г) сахара",
                "1 крупное яйцо, взбитое",
                "1 ч.л. ванильного экстракта",
                "1 1/2 стакана (205г) муки",
                "1/2 стакана орехов пекан (по желанию)",
                "1/2 стакана черники (по желанию)"
            ]
        },
        instructions: { 
            en: [
                "Preheat oven to 350°F (175°C). Butter an 8x4-inch loaf pan.",
                "In a mixing bowl, mash ripe bananas with a fork until smooth. Stir in melted butter.",
                "Mix in baking soda and salt. Stir in sugar, beaten egg, and vanilla extract.",
                "Mix in flour until just combined. Fold in pecans or blueberries if using.",
                "Pour batter into prepared loaf pan.",
                "Bake for 55-65 minutes until toothpick inserted in center comes out clean.",
                "Cool in pan for few minutes, then remove and cool completely before slicing."
            ],
            ua: [
                "Розігрійте духовку до 175°C. Змастіть форму 8x4 дюйми маслом.",
                "У мисці розім'ніть банани виделкою до гладкості. Додайте розтоплене масло.",
                "Додайте соду та сіль. Перемішайте з цукром, яйцем та ванільним екстрактом.",
                "Додайте борошно до об'єднання. За бажанням додайте пекан або чорницю.",
                "Вилийте тісто у підготовлену форму.",
                "Випікайте 55-65 хвилин до готовності (зубочистка виходить чистою).",
                "Охолодіть у формі кілька хвилин, потім вийміть і повністю охолодіть перед нарізкою."
            ],
            es: [
                "Precaliente el horno a 175°C. Engrase un molde de pan de 8x4 pulgadas.",
                "En un tazón, triture los plátanos con un tenedor hasta que estén suaves. Mezcle con mantequilla derretida.",
                "Agregue bicarbonato y sal. Mezcle con azúcar, huevo batido y extracto de vainilla.",
                "Incorpore la harina hasta combinar. Agregue nueces o arándanos si los usa.",
                "Vierta la masa en el molde preparado.",
                "Hornee 55-65 minutos hasta que un palillo salga limpio del centro.",
                "Enfríe en el molde unos minutos, luego desmolde y enfríe completamente antes de cortar."
            ],
            ru: [
                "Разогрейте духовку до 175°C. Смажьте форму 8x4 дюйма маслом.",
                "В миске разомните бананы вилкой до гладкости. Добавьте растопленное масло.",
                "Добавьте соду и соль. Перемешайте с сахаром, яйцом и ванильным экстрактом.",
                "Добавьте муку до объединения. При желании добавьте орехи или чернику.",
                "Вылейте тесто в подготовленную форму.",
                "Выпекайте 55-65 минут до готовности (зубочистка выходит чистой).",
                "Охладите в форме несколько минут, затем выньте и полностью охладите перед нарезкой."
            ]
        },
        image: bananaBreadImg,
        author: CHEFS.ILLYA_BAKUROV,
        country: "",
        cuisine: CUISINE_TYPES.DESSERT,
        type: RECIPE_TYPES.VEGETARIAN,
        nutrition: {
            kcal: 245,
            protein: 4,
            carbs: 45,
            fat: 8,
            servings: 8
        },
        date: "",
        photos: [bananaBreadImg],
        materials: [KITCHEN_MATERIALS.MIXING_BOWL, KITCHEN_MATERIALS.BAKING_DISH],
        youtube: "https://www.youtube.com/embed/6Xvi1zFy8_o?si=HyUwgOdLhrKuy4BY"
    },
    {
        id: "glazed-fried-tofu",
        title: { 
            en: "Glazed Fried Tofu with Sesame Seeds",
            ua: "Глазурований смажений тофу з кунжутом",
            es: "Tofu frito glaseado con semillas de sésamo",
            ru: "Глазированный жареный тофу с кунжутом"
        },
        description: { 
            en: "Crispy fried tofu cubes marinated in teriyaki and soy sauce, served on a bed of toasted sesame seeds.",
            ua: "Хрусткі кубики тофу, маринованого в теріякі та соєвому соусі, подаються на підстилці з смаженого кунжуту.",
            es: "Cubos de tofu frito crujiente marinado en teriyaki y salsa de soja, servido sobre semillas de sésamo tostadas.",
            ru: "Хрустящие кубики жареного тофу, маринованные в терияки и соевом соусе, подаются на подушке из жареного кунжута."
        },
        prepTime: {
            en: "15 minutes",
            ua: "15 хвилин",
            es: "15 minutos",
            ru: "15 минут"
        },
        cookTime: {
            en: "10 minutes",
            ua: "10 хвилин",
            es: "10 minutos",
            ru: "10 минут"
        },
        ingredients: { 
            en: [
                "400g firm tofu, cut into cubes",
                "2 tbsp teriyaki sauce and glaze",
                "1 tbsp soy sauce",
                "1 tsp mustard",
                "2 tbsp olive oil",
                "2 tbsp sesame seeds (Ben estimated it to be 1 million and 32 seeds)"
            ],
            ua: [
                "400г твердого тофу, нарізаного кубиками",
                "2 ст.л. соусу і глазурі теріякі",
                "1 ст.л. соєвого соусу",
                "1 ч.л. гірчиці",
                "2 ст.л. оливкової олії",
                "2 ст.л. кунжутного насіння (Бен оцінив це в 1 мільйон і 32 насіння)"
            ],
            es: [
                "400g de tofu firme, cortado en cubos",
                "2 cucharadas de salsa y glaseado teriyaki",
                "1 cucharada de salsa de soja",
                "1 cucharadita de mostaza",
                "2 cucharadas de aceite de oliva",
                "2 cucharadas de semillas de sésamo (Ben estimó que eran 1 millón y 32 semillas)"
            ],
            ru: [
                "400г твердого тофу, нарезанного кубиками",
                "2 ст.л. соуса и глазури терияки",
                "1 ст.л. соевого соуса",
                "1 ч.л. горчицы",
                "2 ст.л. оливкового масла",
                "2 ст.л. кунжутных семечек (Бен оценил это в 1 миллион и 32 семечки)"
            ]
        },
        instructions: { 
            en: [
                "Cut tofu into small cubes.",
                "In a bowl, mix tofu with mustard, teriyaki sauce, soy sauce, and olive oil.",
                "Let the tofu marinate for 5-10 minutes to soak up all the flavors.",
                "Heat a frying pan over medium heat.",
                "Add sesame seeds to the dry pan and toast them until fragrant.",
                "Carefully add the marinated tofu to the pan on top of the sesame seeds.",
                "Fry until tofu becomes brown and glazed, turning occasionally.",
                "Serve hot with the toasted sesame seeds."
            ],
            ua: [
                "Наріжте тофу невеликими кубиками.",
                "У мисці змішайте тофу з гірчицею, соусом теріякі, соєвим соусом та оливковою олією.",
                "Дайте тофу маринуватися 5-10 хвилин, щоб воно вбрало всі смаки.",
                "Розігрійте сковороду на середньому вогні.",
                "Додайте кунжутне насіння на суху сковороду і обсмажте до ароматності.",
                "Обережно додайте маринований тофу на сковороду поверх кунжуту.",
                "Смажте до зарум'янення та глазурування тофу, періодично перевертаючи.",
                "Подавайте гарячим з смаженим кунжутом."
            ],
            es: [
                "Corte el tofu en cubos pequeños.",
                "En un tazón, mezcle el tofu con mostaza, salsa teriyaki, salsa de soja y aceite de oliva.",
                "Deje marinar el tofu por 5-10 minutos para que absorba todos los sabores.",
                "Caliente una sartén a fuego medio.",
                "Agregue las semillas de sésamo a la sartén seca y tuéstelas hasta que estén aromáticas.",
                "Agregue cuidadosamente el tofu marinado a la sartén sobre las semillas de sésamo.",
                "Fría hasta que el tofu se dore y glasee, volteando ocasionalmente.",
                "Sirva caliente con las semillas de sésamo tostadas."
            ],
            ru: [
                "Нарежьте тофу небольшими кубиками.",
                "В миске смешайте тофу с горчицей, соусом терияки, соевым соусом и оливковым маслом.",
                "Дайте тофу мариноваться 5-10 минут, чтобы оно впитало все вкусы.",
                "Разогрейте сковороду на среднем огне.",
                "Добавьте кунжутные семечки на сухую сковороду и обжарьте до ароматности.",
                "Осторожно добавьте маринованный тофу на сковороду поверх кунжута.",
                "Жарьте до румяности и глазирования тофу, периодически переворачивая.",
                "Подавайте горячим с жареным кунжутом."
            ]
        },
        image: glazedTofuImg,
        author: CHEFS.ILLYA_BAKUROV,
        country: "",
        cuisine: CUISINE_TYPES.MAIN,
        type: RECIPE_TYPES.VEGETARIAN,
        nutrition: {
            kcal: 180,
            protein: 12,
            carbs: 8,
            fat: 12,
            servings: 4
        },
        date: "",
        photos: [glazedTofuImg],
        materials: [KITCHEN_MATERIALS.MIXING_BOWL, KITCHEN_MATERIALS.FRYING_PAN],
        youtube: "https://www.youtube.com/embed/IkcXHbb5cnw?si=ZceHw3cFlJAs4apH"
    }
];

export { demoRecipes };
